import {
	Button,
	DialogActions,
	DialogContent,
	DialogTitle,
	Typography,
} from "@mui/material";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { StyledDialog } from "Shared/Dialogs/DialogStyles";

type Props = {
	isOpen: boolean;
	handleResult: (result: boolean) => void;
	modalTitle: string | JSX.Element;
	modalContent: string | JSX.Element;
	confirmButtonText?: string;
	modalMaxWidth?: string | undefined;
};

export const BlConfirmDialog: React.FunctionComponent<Props> = (props) => {
	const { t } = useResource();
	const {
		modalContent,
		modalTitle,
		confirmButtonText,
		handleResult,
		isOpen,
		modalMaxWidth,
	} = props;

	return (
		<StyledDialog
			open={isOpen}
			onClose={() => handleResult(false)}
			modalMaxWidth={modalMaxWidth}
		>
			<DialogTitle variant="h2">{modalTitle}</DialogTitle>

			{/* <DialogContent dividers>{modalContent}</DialogContent> */}
			<DialogContent>
				<Typography>{modalContent}</Typography>
			</DialogContent>

			<DialogActions>
				<Button color="primary" onClick={() => handleResult(true)}>
					{confirmButtonText ?? t(Resources.Common.Confirm)}
				</Button>
				<Button onClick={() => handleResult(false)}>
					{t(Resources.Common.Cancel)}
				</Button>
			</DialogActions>
		</StyledDialog>
	);
};
